import { render, staticRenderFns } from "./MultiDepartmentListSelectorDialog.vue?vue&type=template&id=3fdc5906&scoped=true&"
import script from "./MultiDepartmentListSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./MultiDepartmentListSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MultiDepartmentListSelectorDialog.vue?vue&type=style&index=0&id=3fdc5906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc5906",
  null
  
)

export default component.exports